import Highcharts from 'highcharts';
import Utils from './project_charts_utils.js';
import Spinnerable from './spinnerable.js';

const PieChart = {
  totalValue: 0,

  init(containerId) {
    this.containerId = containerId;
    this.container = $(`#${this.containerId}`);
    this._spinner = this.container.parent().find('.spinner');
    this.listenToSideBarToggleEvent();
    this.listenToWindowResize();
    return this;
  },

  listenToSideBarToggleEvent() {
    $(document).on('sidebar-toggled', _.bind(this.updateWidth, this));
  },

  listenToWindowResize() {
    $(window).on('resize', _.bind(this.updateWidth, this));
  },

  updateWidth() {
    this.chart.update({ chart: { width: this.container.width() } });
  },

  render(entries, searchState) {
    this.searchState = searchState;
    this.prepareChart(entries);
    this.chart = this.renderChart();
    this._setTotal();
  },

  prepareChart(entries) {
    if (!this._rendered) {
      this._renderChartContainer();
    }
    this.entries = entries;
    this.groups = this.generateGroups(this.entries);
  },

  renderChart() {
    this.chartContainer.html('');

    return Highcharts.chart(this.chartContainer[0], {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        styledMode: false,
        events: {
          load: this.hideSpinner
        }
      },
      subtitle: {
        text: '<b>$Total Bn</b>',
        align: 'center',
        verticalAlign: 'middle',
        style: {
          color: "#3b434c",
          'font-size': '1.52rem'
        },
        y: 5
      },
      title: {
        text: this.title,
        align: 'left'
      },
      exporting: {
        enabled: true
      },
      credits: {
        enabled: false
      },
      tooltip: {
        pointFormat: '{point.percentage:.1f}%'
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            formatter: this._valueFormatter,
            style: {
              color: "#3b434c"
            }
          },
          startAngle: 0,
          endAngle: 360,
          center: ['50%', '50%'],
          size: '70%'
        }
      },
      series: [{
        type: 'pie',
        innerSize: '50%',
        allowPointSelect: true,
        data: this.series()
      }]
    });
  },

  _valueFormatter() {
    return `<b>${this.key}</b><br><div style='font-weight:normal'>${convertNbToString(this.y)} (${Math.round(this.percentage * 100) / 100}%)</div>`;
  },

  _renderChartContainer() {
    return this.chartContainer = $('<div>').appendTo(this.container);
  },

  translate(key) {
    return I18n.t(`enumerize.project.short_status.${key}`);
  },

  _setTotal() {
    const total = this._roundToTwo(this.totalValue);
    return this.chart.setSubtitle({ text: `<b>${this.convertNbToString(total)}</b>` });
  },

  series() {
    this.totalValue = 0;
    const refinedSectors = this.searchState.disjunctiveFacetsRefinements.sectors;
    return _.map(this.groups, (value, key) => {
      const collection = (() => {
        if (this.containerId === 'sectors-breakdown-chart') {
          if (((refinedSectors == null)) || ((refinedSectors || []).includes(key))) {
            return $.map(value, project => project["sectors_budget"][key]);
          }
        } else {
          return _.pluck(value, 'formatted_budget');
        }
      })();
      if (collection) {
        const total = _.reduce(collection, (memo, v) => memo + v);
        this.totalValue += total;
        return [
          this.translate(key),
          total
        ];
      } else {
        return null;
      }
    });
  }
};

_.defaults(PieChart, Utils);
_.defaults(PieChart, Spinnerable);

export default PieChart;